import React from 'react';
import PropTypes from 'prop-types';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = 'PowerSupply.string';

export function Heading(props) {
  const {
    t,
    //i18n
  } = useTranslation();
  const TEXT = t(TRANSLATION_KEY);

  return <h1 className='ps_heading'>{TEXT}</h1>;
}

Heading.propTypes = {};
Heading.defaultProp = {};
